import dayjs from 'dayjs';

// Numeric timestamps from the API are Unix seconds.
export const parseDate = (value) => (typeof value === 'number' ? dayjs.unix(value) : dayjs(value));

export const createWeekdayFormatter = (locale) => {
  const formatter = new Intl.DateTimeFormat(locale, { weekday: 'long', timeZone: 'UTC' });
  // January 3, 2000 was a Monday; schedules use Monday-first day indices.
  return (index) => formatter.format(new Date(Date.UTC(2000, 0, 3 + index)));
};

export const createTimeFormatter = (locale) => {
  const formatter = new Intl.DateTimeFormat(locale, {
    timeStyle: 'short',
    timeZone: 'UTC',
  });

  // A schedule stores a wall-clock time, independent of today's date and DST.
  return (time) => formatter.format(new Date(`2000-01-01T${time}Z`));
};
